// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"p7-z"};